import { render, staticRenderFns } from "./knipper.vue?vue&type=template&id=44e8cf08&scoped=true&v-once=true"
import script from "./knipper.vue?vue&type=script&lang=js"
export * from "./knipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e8cf08",
  null
  
)

export default component.exports